/**
 * The card an embed renders when the organization's plan does not include embeds (SMA-76):
 * never a broken widget on a customer's site. The organization name and the hosted page
 * come from the public API's refusal.
 */
import { Show } from 'solid-js'

export default function EmbedUnavailable(props) {
  return (
    <div class="p-6 text-center border border-gray-200 rounded-lg bg-white dark:bg-gray-800 dark:border-gray-700" data-embed-unavailable>
      <Show when={props.organizationName}>
        <p class="text-base font-semibold text-gray-900 dark:text-white">{props.organizationName}</p>
      </Show>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Security disclosure program</p>
      <Show when={props.publicUrl}>
        <a
          href={props.publicUrl}
          target="_blank"
          rel="noopener noreferrer"
          class="mt-3 inline-block text-sm font-medium text-gray-900 underline dark:text-white"
        >
          View the program
        </a>
      </Show>
    </div>
  )
}
